module.exports = new __parcel__URL__("archer-building.42c13417.webp").toString();